import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import PropTypes from 'prop-types';
import { Flex, Box } from 'grid-styled';
import { FullWidthContainer } from '../styles/FullWidthContainer';
import { Container } from '../styles/Container';
import { size } from '../styles/helpers/variables';

const ArticleImageBlock = props => (
  <FullWidthContainer>
    <ArticleImageBlockContainer>
      <ThemeProvider
        theme={{
          breakpoints: [`${size.medium}px`]
        }}
      >
        <Flex flexWrap="wrap" mx={[0, '-14px']}>
          <Box width={[1, 1 / 2]} p={[0, '14px']}>
            <ImageBlock image={props.leftImage} />
          </Box>
          <Box width={[1, 1 / 2]} p={[0, '14px']}>
            <ImageBlock image={props.rightImage} />
          </Box>
        </Flex>
      </ThemeProvider>
    </ArticleImageBlockContainer>
  </FullWidthContainer>
);

const ArticleImageBlockContainer = Container.extend`
  padding-top: 80px;
  padding-bottom: 50px;
`;

const ImageBlock = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 71.5%;
  background-image: url("${props => props.image}");
  background-size: cover;
  background-position: center;
  margin: 10px 0;
`;

ArticleImageBlock.defaultProps = {
  leftImage: null,
  rightImage: null
};

ArticleImageBlock.propTypes = {
  leftImage: PropTypes.string,
  rightImage: PropTypes.string
};

export default ArticleImageBlock;



// WEBPACK FOOTER //
// ./src/components/ArticleImageBlock.js